export default "__VITE_ASSET__BC8DKq24__"